<div class="fetch-error-background-container">
    <p>{{data.messageToDisplay}}</p>
    <button class="btn btn-information" (click)="dialogRef.close()">{{data.buttonToDisplay}}</button>
</div>